module.exports = __webpack_public_path__ + "static/media/press-small.8707cf47.webp";